export function defined<T>(obj: T | undefined | null): T {
  if (obj === undefined || obj === null) {
    throw new Error('Object undefined.');
  }

  return obj;
}
